var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQrCodeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2857 4.57143H22.2857V6.7619H19.2857V8.95238H22.2857V15.5238H19.2857V17.7143H16.2857V13.3333H19.2857V11.1429H16.2857V4.57143Z",
    fill: "black",
    fillOpacity: 0.64
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.57143 16.8571H6.77551V20.2857H4.57143V16.8571ZM8.97959 16.8571H13.3878V20.2857H8.97959V16.8571ZM20 16.8571H22.2041V20.2857H20V16.8571ZM24.4082 16.8571H28.8163V20.2857H24.4082V16.8571ZM35.4286 20.2857H33.2245V16.8571H35.4286V20.2857Z",
    fill: "black",
    fillOpacity: 0.64
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.85714 20.2857H9.05494V22.2857H6.85714V20.2857ZM11.2527 20.2857H20.044V22.2857H11.2527V20.2857ZM26.6374 20.2857H28.8352V22.2857H26.6374V20.2857ZM35.4286 22.2857H31.033V20.2857H35.4286V22.2857Z",
    fill: "black",
    fillOpacity: 0.64
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2857 21.4286H20.4082V24.5714H18.2857V21.4286ZM22.5306 21.4286H24.6531V24.5714H22.5306V21.4286ZM33.1429 24.5714H31.0204V21.4286H33.1429V24.5714Z",
    fill: "black",
    fillOpacity: 0.64
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4286 24.5714H18.381V26.5714H15.4286V24.5714ZM33.1429 26.5714H21.3333V24.5714H33.1429V26.5714Z",
    fill: "black",
    fillOpacity: 0.64
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7143 26.5714H19.9286V28.8571H17.7143V26.5714ZM22.1429 26.5714H24.3571V28.8571H22.1429V26.5714ZM28.7857 26.5714H31V28.8571H28.7857V26.5714ZM35.4286 28.8571H33.2143V26.5714H35.4286V28.8571Z",
    fill: "black",
    fillOpacity: 0.64
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7143 28.8571H22.1224V31.1429H17.7143V28.8571ZM24.3265 28.8571H26.5306V31.1429H24.3265V28.8571ZM33.1429 31.1429H28.7347V28.8571H33.1429V31.1429Z",
    fill: "black",
    fillOpacity: 0.64
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7143 31.1429H19.9286V33.7143H17.7143V31.1429ZM26.5714 31.1429H28.7857V33.7143H26.5714V31.1429ZM35.4286 33.7143H33.2143V31.1429H35.4286V33.7143Z",
    fill: "black",
    fillOpacity: 0.64
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7143 33.1429H28.6667V36.2857H19.7143V33.1429ZM33.1429 36.2857H30.9048V33.1429H33.1429V36.2857Z",
    fill: "black",
    fillOpacity: 0.64
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4286 2.28571H4.57143C3.30906 2.28571 2.28571 3.30906 2.28571 4.57143V35.4286C2.28571 36.6909 3.30906 37.7143 4.57143 37.7143H35.4286C36.6909 37.7143 37.7143 36.6909 37.7143 35.4286V4.57143C37.7143 3.30906 36.6909 2.28571 35.4286 2.28571ZM4.57143 0C2.0467 0 0 2.0467 0 4.57143V35.4286C0 37.9533 2.0467 40 4.57143 40H35.4286C37.9533 40 40 37.9533 40 35.4286V4.57143C40 2.0467 37.9533 0 35.4286 0H4.57143Z",
    fill: "black",
    fillOpacity: 0.64
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.71429 5.71429V11.1429H11.4286V5.71429H5.71429ZM5.14286 4.57143C4.82727 4.57143 4.57143 4.82727 4.57143 5.14286V11.7143C4.57143 12.0299 4.82727 12.2857 5.14286 12.2857H12C12.3156 12.2857 12.5714 12.0299 12.5714 11.7143V5.14286C12.5714 4.82727 12.3156 4.57143 12 4.57143H5.14286Z",
    fill: "black",
    fillOpacity: 0.64
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.71429 28.8571V34.2857H11.4286V28.8571H5.71429ZM5.14286 27.7143C4.82727 27.7143 4.57143 27.9701 4.57143 28.2857V34.8571C4.57143 35.1727 4.82727 35.4286 5.14286 35.4286H12C12.3156 35.4286 12.5714 35.1727 12.5714 34.8571V28.2857C12.5714 27.9701 12.3156 27.7143 12 27.7143H5.14286Z",
    fill: "black",
    fillOpacity: 0.64
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5714 5.71429V11.1429H34.2857V5.71429H28.5714ZM28 4.57143C27.6844 4.57143 27.4286 4.82727 27.4286 5.14286V11.7143C27.4286 12.0299 27.6844 12.2857 28 12.2857H34.8571C35.1727 12.2857 35.4286 12.0299 35.4286 11.7143V5.14286C35.4286 4.82727 35.1727 4.57143 34.8571 4.57143H28Z",
    fill: "black",
    fillOpacity: 0.64
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7.42857 7.42857H9.71429V9.71429H7.42857V7.42857Z",
    fill: "black",
    fillOpacity: 0.64
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M7.42857 30.5714H9.71429V32.8571H7.42857V30.5714Z",
    fill: "black",
    fillOpacity: 0.64
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2857 7.42857H32.5714V9.71429H30.2857V7.42857Z",
    fill: "black",
    fillOpacity: 0.64
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCodeIcon);
export default __webpack_public_path__ + "static/media/qrCodeIcon.3c439a013ed8ac1b22b4d81defdea4b9.svg";
export { ForwardRef as ReactComponent };